import React, { useEffect, useRef } from 'react'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import styles from 'components/mvv/Mvv/Brand.module.scss'

gsap.registerPlugin(ScrollTrigger)

const tweenVars = {
  y: 50,
  opacity: 0,
  duration: 1,
  ease: Power4.easeOut,
}

const OurMission: React.FC = () => {
  const sectionRef = useRef<HTMLElement | null>(null)

  useEffect(() => {
    if (sectionRef.current) {
      const elements = sectionRef.current.querySelectorAll(
        `.${styles.section_top_mission}, .${styles.section_body_mission}, .${styles.section_body_ttl_mission}, .${styles.section_body_desc_mission}`,
      )

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: sectionRef.current,
          start: 'top 80%',
          toggleActions: 'play none none reverse',
        },
      })

      tl.fromTo(
        elements,
        { opacity: 0, y: 50 }, // 初期状態
        { opacity: 1, y: 0, duration: 1, stagger: 0.3, ease: Power4.easeOut }, // アニメーション終了時の状態
      )
    }

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill())
    }
  }, [])

  return (
    <section className={styles.section} ref={sectionRef}>
      <div className={styles.inner}>
        <div className={`${styles.section_top} ${styles.section_top_mission}`}>
          <span className={styles.section_top_icon}></span>
          <h2 className={styles.section_top_ttl}>
            <span className={styles.section_top_ttl_en}>Our mission</span>
            <span className={styles.section_top_ttl_ja}>存在意義</span>
          </h2>
        </div>
        <div className={`${styles.section_body} ${styles.section_body_mission}`}>
          <h3 className={`${styles.section_body_ttl} ${styles.section_body_ttl_mission}`}>
            <span className={styles.section_body_ttl_ja}>
              デザインとテクノロジーの力で、
              <br />
              日本を再度競争力のある国にする
            </span>
            <span className={styles.section_body_ttl_en}>
              Revitalizing Japan&apos;s global competitiveness through design and technology
            </span>
          </h3>
          <p className={`${styles.section_body_desc} ${styles.section_body_desc_mission}`}>
            高齢化と労働生産人口の減少といった構造的な問題に直面している日本が再び競争力のある国になるためには、デジタル産業における遅れを挽回し、先進国としての地位を取り戻すことが重要です。この目標を達成するには、AIを核とするテクノロジーの積極的な活用、最新のフレームワークやメソドロジーの導入、そしてトライ＆エラーを繰り返すことで成り立つ継続的な改善サイクルを取り入れることが必要です。
            <br />
            i3DESIGNは、こうした最新の手法やツールを通して絶対的な顧客価値を追求していきます。
          </p>
        </div>
      </div>
    </section>
  )
}

export default OurMission
